import { useState } from "react";
import * as S from "./MainPostTab.style";
import { RangeType } from "@/pages/MainPage";

interface MainPostTabProps {
  children?: React.ReactNode;
  onTabChange: (tabId: RangeType) => void;
}

export const MainPostTab = ({ children, onTabChange }: MainPostTabProps) => {
  const TabData = [
    { id: "today", button: "오늘" },
    { id: "week", button: "주간" },
    { id: "month", button: "월간" },
  ];

  const [activeTab, setActiveTab] = useState(TabData[0].id);
  const handleClickTab = (tabId: RangeType) => {
    setActiveTab(tabId);
    onTabChange(tabId);
  };

  return (
    <S.MainPostTab>
      <S.TabBox>
        {TabData.map((tab: any) => (
          <S.TabButton
            key={tab.id}
            $active={activeTab === tab.id}
            onClick={() => handleClickTab(tab.id)}
          >
            {tab.button}
          </S.TabButton>
        ))}
      </S.TabBox>
      {children}
    </S.MainPostTab>
  );
};
